// @flow

export default class KeydownConfig {
  namespace: string;
  handler: Function;
  keyCodes: number[];
  modifiers: number[];
  checkTarget: boolean;
  shouldPreventDefault: boolean;
  shouldStopPropagation: boolean;

  constructor(
    namespace: string,
    handler: Function,
    keyCodes: number[],
    modifiers?: number[],
    checkTarget?: boolean = true,
    shouldPreventDefault?: boolean = true,
    shouldStopPropagation?: boolean = true
  ) {
    this.namespace = namespace;
    this.handler = handler;
    this.keyCodes = keyCodes;
    this.modifiers = modifiers || [];
    this.checkTarget = checkTarget;
    this.shouldPreventDefault = shouldPreventDefault;
    this.shouldStopPropagation = shouldStopPropagation;
  }

  validate() {
    return this.namespace && this.handler && this.keyCodes.length;
  }
}
